export enum EEvaluationStep
{
    GO,
    NO_GO
}